<template>
    <div>
        <Breadcrumbs title="Dashboard"/>
        <!-- Container-fluid starts-->
        <div class="container-fluid">
            <div class="row">
              <div class="col-md-12">
                <div class="card">
                    <div class="card-header">
                      <h5>Selamat Datang {{ userDetail.namaLengkap }}</h5><span>Ujian Online Berbasis Komputer Darunnajah</span>
                    </div>
                    <div class="card-body">
                      <p></p>
                    </div>
                </div>
              </div>               
            </div>
        </div>
        <!-- Container-fluid Ends-->
    </div>
</template>

<script>
import {helper} from '@/services/helper';
export default {
  data(){
    return{
        userDetail: {}
    }
  },
  mounted() {
    //this.getAllKelas();
    let user = localStorage.getItem("user");
    if (user) {
        this.userDetail = helper.getUserObject(user);        
    }
  }
}
</script>